/* eslint-disable no-useless-escape */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';
import '../../assets/css/bookNow.css';

import Fade from 'react-reveal/Fade';
import * as emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import Form from './index.js';

export default function (props) {
  const { data, resetForm } = props;

  const submitEmail = () => {
    const {
      name, company, email, phone, projectIdea,
    } = data;

    const templateParams = {
      from_name: `${name} - ${company} ( ${phone} - ${email} )`,
      to_name: 'Signature Move',
      message: projectIdea,
    };

    if (
      name !== ''
            && company !== ''
            && email !== ''
            && phone !== ''
            && projectIdea !== ''
    ) {
      emailjs.send(
        'service_m9ez6le',
        'template_8b22j2g',
        templateParams,
        'user_Jmss4bRHKILhJ0KTp7Zxf',
      )
        .then(() => {
          toast.success('Success! we\'\ll get back to you soon. Thank you!');
          resetForm();
        }, (error) => {
          // toast.error(error);
        });
    } else {
      // toast.error('Please fill out the blank form.');
    }
  };

  return (
    <section >
      <Fade bottom>
        <h1 style={{display: 'flex', justifyContent: 'center'}}>Contact Us</h1>

        <p className="font-light text-lg text-gray-400 text-center mb-12">          
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          Please fill out the form below and we'll get back to you ASAP.
        </p>

        <div >
          <div className="selectInputs">
            <input
              id="name"
              name="name"
              type="text"
              value={data.name}
              placeholder="Your name"
              className='inputText'
              onChange={props.onChange}
            />
            <input
              id="company"
              name="company"
              type="text"
              value={data.company}
              placeholder="Your company"
              className='inputText'
              onChange={props.onChange}
            />
          </div>

          <div className="selectInputs">
            <input
              id="email"
              name="email"
              type="email"
              value={data.email}
              placeholder="Your email address"
              className='inputText'
              onChange={props.onChange}
            />

            <input
              id="phone"
              name="phone"
              type="tel"
              value={data.phone}
              placeholder="Your contact number"
              className='inputText'
              onChange={props.onChange}
            />
          </div>

          <div style={{display: 'flex', justifyContent: 'center'}} className="mx-auto">
            <input
              id="projectIdea"
              name="projectIdea"
              type="textarea"
              width="200px"
              value={data.projectIdea}
              placeholder="Explain about your project idea"
              className='inputText'
              onChange={props.onChange}
            />
          </div>

<div style={{display: 'flex', justifyContent: 'center'}}>
          <button
           
            className="btnStyle btnActive"
            type="button"
            onClick={submitEmail}
          >
            Submit
          </button>
          </div>
        </div>
      </Fade>

      <ToastContainer />

    </section>
  );
}

